import { serverBus } from './main'
import Vue from 'node_modules/vue'

export default function () {
  return {
    pollMdnEventData () {
      let success = function (result) {
        serverBus.$emit('mdnEventDataUpdated', result.data)
        Vue.notify({
          group: 'notify',
          type: 'success',
          text: 'Data updated successfully'
        })
      }

      let failure = function () {
        Vue.notify({
          group: 'notify',
          type: 'error',
          text: 'Error occured during data polling...'
        })
      }

      this.$http.get('data.json').then(success, failure)
      console.log('Data polled')
    },
    setPollingEnabled (enabled) {
      serverBus.$emit('mdnEventDataPollingEnabled', enabled)
      console.log('polling ' + enabled)
    }
  }
}
